import AirDatepicker from 'air-datepicker';
import deLang from 'air-datepicker/locale/de';


document.querySelectorAll('[data-element-type="DatePicker"]').forEach(el => {
    console.debug('initialising datepicker with format', el.dataset.elementDatepickerDateFormat)
    new AirDatepicker(el, {
        locale: deLang,
        dateFormat: el.dataset.elementDatepickerDateFormat,
        minDate: el.dataset.future === '1' ? new Date() : '',
    });
});
